import React from "react";
import { BrowserRouter, Route, Link } from "react-router-dom";
import Timeline from "./Timeline";
import {
  Card,
  CardText,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardHeader,
  CardDeck,
  CardImg,
  CardColumns
} from "reactstrap";
import LoadingSpinner from "./LoadingSpinner";
import Poems from './PoemsList'
import { connect } from 'react-redux'
import PoetsList from './PoetsList'
import PoemPage from './PoemPage';

class Nav extends React.Component {
  constructor() {
    super();
    this.state = { query: "" };
  }

  render() {
    return (
      <div>
        <LoadingSpinner visible={this.props.loading} />
        <BrowserRouter>
          { !this.props.loading && <div
            className="container" >
            <nav className="navbar sticky-top navbar-light bg-light">
              <Link to="/">الخط الزمني</Link>
              &nbsp;
              <Link to="/tags">الشخصيات</Link>
              &nbsp;
              <Link to="/poems">القصائد</Link>
            </nav>
            <div>
              <br />
              <Route
                exact
                path="/"
                render={() => <Timeline />}
              />
              <Route
                exact
                path="/tags"
                render={() => <PoetsList {...this.props} />}
              />
              <Route
                exact
                path="/poems"
                render={() => <Poems/>}
              />
              <Route exact path="/poem/:poemId"
              component={PoemPage}/>
            </div>
          </div>}
        </BrowserRouter>
      </div>
    );
  }
}


function mapStateToProps(state){
  return {...state};
}

export default connect(mapStateToProps)(Nav);



// WEBPACK FOOTER //
// ./src/nav.js